import './AgencyCodesErrorFallback.scss';

export function AgencyCodesErrorFallback() {
  return <div className="agency-codes-error">Agency codes cannot be displayed right now. Please refresh the page and try again.</div>;
}
